import { monthAbbreviationsList } from '@enums/PlanType';
import { isBefore, subDays } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

export const toUtcMidnight = (dateString): string => {
  const date = new Date(dateString);
  date.setUTCHours(0, 0, 0, 0);
  return date.toISOString();
};

export const formatDate = (dateString): string => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-us', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const formatDateTime = (dateString): string =>
  new Date(dateString).toLocaleString('en-us', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });

/** Determines if date is yesterday or earlier. */
export const isDatePast = (dateString: string): boolean => {
  const yesterday = subDays(new Date(), 1);
  return isBefore(new Date(dateString), yesterday);
};

/*
 *
 * Given a UTC string from the database, formats a date string in the provided tz or
 * the browser's timezone.
 * Example return: Mar 30, 2023, 8:00 AM
 *
 */

type FormatUTCStringToTimezoneStringArgs = {
  dateString: string;
  timeZone?: string;
};

export const formatUTCStringToTimezoneString = ({
  dateString,
  timeZone,
}: FormatUTCStringToTimezoneStringArgs): string => {
  if (!dateString) return 'Unknown Date';

  const utcString = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
  const utcDate = new Date(utcString);
  const formatted = utcDate.toLocaleString('en-US', {
    timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    minute: 'numeric',
    hour: 'numeric',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  return `${formatted} ${timeZone ? `(${timeZone})` : ''}`;
};

export const formatToUTCString = (dateString: string) => {
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(dateString);
  const utcDate = zonedTimeToUtc(date, browserTimezone);
  return utcDate.toISOString();
};

export const formatUtcDateToDateString = (dateString): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const formattedDate = `${monthAbbreviationsList[month]} ${day}, ${year}`;
  return formattedDate;
};
